import React from 'react';
import CreatableSelect from 'react-select/creatable';
import {MultiValue} from "react-select";
import {IOptionType} from "../../../types/common";
import {OverlayTooltip} from "../../../components";

interface ManufacturersSelectProps {
    title: string;
    options: IOptionType[];
    selectedItems: IOptionType[];
    isDisabled: boolean;
    onChange: (values: MultiValue<IOptionType>) => void;
    placeholder: string;
    tooltipContent: string;
}

const ManufacturersSelect: React.FC<ManufacturersSelectProps> = ({
                                                                     title,
                                                                     options,
                                                                     selectedItems,
                                                                     isDisabled,
                                                                     onChange,
                                                                     placeholder,
                                                                     tooltipContent,
                                                                 }) => (
    <div className="d-flex flex-column gap-2">
        <div className="d-flex flex-row align-items-baseline gap-1">
            <span>{title}</span>
            <OverlayTooltip tooltipContent={tooltipContent}/>
        </div>
        <CreatableSelect
            isDisabled={isDisabled}
            className="card border-0 d-md-block"
            closeMenuOnSelect={false}
            isMulti
            options={options}
            defaultValue={selectedItems}
            placeholder={placeholder}
            onChange={(items) => onChange(items)}
        />
    </div>
);

export default ManufacturersSelect;
